﻿import { ExpandMore } from "@mui/icons-material";
import {
	Box,
	Collapse,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useState } from "react";
import {
	HeatEventSummary,
	ProductionEventSummary,
} from "../../models/SalesOverview";
import {
	cellStyle,
	formatDateTime,
	formatNumber,
	subCellStyle,
	subHeaderCellStyle,
} from "../utils";

type SectionRowProps = {
	event: ProductionEventSummary;
	heats: HeatEventSummary[];
};

export const SectionRow = ({ event, heats }: SectionRowProps) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<TableRow
				onClick={() => setOpen((v) => !v)}
				sx={{
					cursor: "pointer",
					"&:hover": { backgroundColor: "#fafafa" },
				}}
			>
				<TableCell sx={{ ...cellStyle, width: 28, pr: 0 }}>
					<ExpandMore
						fontSize="small"
						sx={{
							fontSize: "1rem",
							color: "#777",
							transform: open ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.2s",
						}}
					/>
				</TableCell>
				<TableCell sx={{ ...cellStyle, fontWeight: 600, color: "#333" }}>
					{event.SectionName ?? `#${event.EventId}`}
				</TableCell>
				<TableCell sx={cellStyle} align="right">
					{formatDateTime(event.EventStart)}
				</TableCell>
				<TableCell sx={cellStyle} align="right">
					{formatDateTime(event.EventEnd)}
				</TableCell>
				<TableCell sx={cellStyle} align="right">
					{formatNumber(event.ScheduledFinishedTons, 1)}
				</TableCell>
				<TableCell sx={cellStyle} align="right">
					{formatNumber(event.BudgetTPH, 1)}
				</TableCell>
			</TableRow>
			<TableRow>
				<TableCell
					colSpan={6}
					sx={{ p: 0, borderBottom: open ? "1px solid #f0f0f0" : "none" }}
				>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ px: 1, py: 0.5, backgroundColor: "#fafafa" }}>
							{heats.length === 0 ? (
								<Typography
									sx={{
										fontSize: "0.7rem",
										color: "#999",
										fontStyle: "italic",
										py: 0.5,
									}}
								>
									No heats for this event
								</Typography>
							) : (
								<Box
									sx={{
										maxHeight: 150,
										marginLeft: 5,
										paddingRight: 2,
										overflowY: "auto",
									}}
								>
									<Table size="small" stickyHeader>
										<TableHead>
											<TableRow>
												<TableCell sx={subHeaderCellStyle}>Heat</TableCell>
												<TableCell sx={subHeaderCellStyle}>Grade</TableCell>
												<TableCell sx={subHeaderCellStyle} align="right">
													Start
												</TableCell>
												<TableCell sx={subHeaderCellStyle} align="right">
													Billets
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{heats.map((h) => (
												<TableRow key={h.HeatId}>
													<TableCell sx={subCellStyle}>{h.HeatName}</TableCell>
													<TableCell sx={subCellStyle}>
														{h.GradeName ?? "-"}
													</TableCell>
													<TableCell sx={subCellStyle} align="right">
														{formatDateTime(h.HeatStart)}
													</TableCell>
													<TableCell sx={subCellStyle} align="right">
														{h.ChargedBillets}
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</Box>
							)}
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
};
